import * as React from "react";

import {cs}                         from "@Common/react/chain-services";
import {consumeContext}             from "@Common/react/context";
import {Load2}                      from "@Common/react/load2";
import {rLsStore}                   from "@Common/react/ls-store";
import {UseState}                   from "@Common/react/use-state";
import {Responsive}                 from "@Common/ui-components/responsive";
import {faSpinner}                  from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon}            from "@fortawesome/react-fontawesome";
import {rFolderTiles}               from "./common/folder-tiles/folder-tiles";
import {UserCreatedAdminLayout}     from "./common/layout/user-created-admin-layout";
import {TemplateUploadModal}        from "./template-upload-modal/template-upload-modal";

export const UserCreatedAdminArchiveRoute = ({}) => cs(
    ["responsive", (_, next) => <Responsive {...{
        sizes: {
            md: 1024,
            lg: 1920,
        },
        next,
    }}/>],
    ["showInactive", (_, next) => rLsStore("uctTiles.showInactiveAdmin", false)({}, next)],
    ["viewMode", ({responsive}, next) => responsive.lt("md") ? next({value: "medium"}) : rLsStore("tiles.viewModeAdmin", "medium")({}, next)],
    ["templateUploadModal",({}, next) => TemplateUploadModal({
        activeTab: 'archive',
        // TODO: Display error message if selection fails
        // onError: (message) => alertModal.show({message}),
        next,
    })],
    ({showInactive, templateUploadModal, viewMode}, next) => UserCreatedAdminLayout({
        activeTab: "archive", folders: {}, showInactive, templateUploadModal, updatingFolderSequence:false, viewMode, next
    }),
    consumeContext("apis"),
    ["forceUpdate", (_, next) => UseState({next})],
    ["folders", ({apis}, next) => Load2({
        fetch: () => apis.next.userCreated.getFolders(),
        next,
    })],
    ({forceUpdate, folders, templateUploadModal, showInactive, viewMode}) => {
        return (<>
            {folders.loading ? (
                <div className="spinner-footer" xd-qa-type="label" xd-qa-name="Loading">
                    <FontAwesomeIcon icon={faSpinner} className="fa-pulse"/>
                </div>
            ) : (
                <div className="archive">
                    {folders.value.map((folder: any, index) => ( rFolderTiles({
                        activeTab:'archive',
                        deleted:1,
                        forceUpdate,
                        index,
                        folder,
                        folders,
                        showInactive: showInactive.value,
                        templateUploadModal,
                        updatingFolderSequence: false,
                        viewMode: viewMode.value,
                        dragulaTemplatesDecorator: ()=>{}}) ))}
                </div>
            )}
            </>);
    },
);